module.exports = {"430524001":"桃花坪街道","430524002":"花门街道","430524101":"小沙江镇","430524102":"金石桥镇","430524103":"司门前镇","430524104":"高平镇","430524105":"六都寨镇","430524106":"荷香桥镇","430524107":"横板桥镇","430524108":"周旺镇","430524109":"滩头镇","430524110":"鸭田镇","430524111":"西洋江镇","430524113":"岩口镇","430524114":"北山镇","430524115":"三阁司镇","430524116":"南岳庙镇","430524117":"七江镇","430524118":"羊古坳镇","430524119":"罗洪镇","430524200":"麻塘山乡","430524201":"虎形山瑶族乡","430524203":"大水田乡","430524207":"荷田乡","430524212":"山界回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430524.json
// module id = 1978
// module chunks = 0